<nz-page-header nzTitle="Workflow List" nzSubtitle="Select the workflow you want to view/edit"></nz-page-header>

<button nz-button nzType="dashed" class="mb-1" (click)="add()">+ Add Workflow</button>
<nz-table nzSize="small" [nzData]="data" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>Mode</th>
			<th>Name</th>
			<th>Label</th>
			<th>Description</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="viewWorkflow(item)">
			<td>{{item.ticketMode}}</td>
			<td>{{item.name}}</td>
			<td>{{item.label}}</td>
			<td>{{item.description}}</td>
		</tr>
	</tbody>
</nz-table>
